import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IWorkingCopyHistoryService = ( createDecorator('workingCopyHistoryService'));
export { IWorkingCopyHistoryService };
